const messages = {
  AIDOO : {
    title: 'Aidoo',
    desc: 'Dispositivo para a gestão e integração de um equipamento de A/C. Opções: <br/> · Wi-Fi <br/> · KNX',
    img: 'https://doc.airzone.es/Resources/Images/IMG_AZAI6xxxxxx.png',
    articles: {
      AIDOO_WIFI: {
        title: 'Controllo Aidoo Wi-Fi',
        desc: 'Dispositivo para a gestão de um equipamento de A/C; controlo através da aplicação Airzone Aidoo, conexão Wi-Fi e integração Modbus',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZAI6WSCxxx.png',
        descResult: 'Controle as suas definições de ar condicionado desde qualquer parte do mundo, com a aplicação <b>Airzone Aidoo</b> (disponível para <a href="https://play.google.com/store/apps/details?id=es.airzone.aidoo" target="_blank" style="color:#007f9b">Android</a> e <a href="https://apps.apple.com/app/airzone-aidoo/id1468065088" target="_blank" style="color:#007f9b">iOS</a>). Compatíveis com:',
        logos: [
          'https://doc.airzone.es/Resources/Images/IMG_logo-Google-Assistant.png',
          'https://doc.airzone.es/Resources/Images/IMG_logo-Alexa.png',
        ],
      },
      AIDOO_KNX: {
        title: 'Controllo Aidoo KNX',
        desc: 'Dispositivo para a gestão de um equipamento de A/C; controlo KNX TP-1 e 3 entradas digitais configuráveis',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZAI6KNXxxx.png',
        descResult: 'Graças à compatibilidade com o software ETS5, pode configurar facilmente o Aidoo KNX e incluí-lo no seu projeto. Descarregar nosso <a href="https://doc.airzone.es/producto/Gama_AZ6/Airzone/Aidoo/BBDD_AZAI6KNX.zip" style="color:#007f9b">base de datos</a>.'
      }
    },
    include: {
      protocolo: '%{article} %{protocolo}: <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a> con:',
      accesrories: [
        'Cabo de conexão à unidade interior.',
        'Parafusos e adesivo de dupla face para montagem.',
      ],
    }
  },
  ZONIFIED : {
    title: 'Gateway para sistema distribuído por zonas',
    desc: 'Gateway para o controlo de um equipamento de condutas distribuído por zonas',
    img: 'https://doc.airzone.es/Resources/Images/IMG_AZX6GTCxxx.png',
    articles: {
      COMMUNICATION_GATEWAY: {
        title: 'Gateways de comunicação',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZX6GTCxxx.png',
        descResult: '',
      }
    },
    include: {
      pack1: 'Gateway comunicações Airzone - %{protocolo} : <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>',
      pack2: 'Gateway controlador 3.0 Airzone - %{protocolo} : <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>',
    }
  },
  MONOZONE : {
    title: 'Módulo de zona para equipamento individual',
    desc: 'Módulo de zona cabo/rádio para o controlo de um equipamento individual',
    img: 'https://doc.airzone.es/Resources/Images/IMG_AZDI6ZMOxxxC.png',
    articles: {
      WIRED_ZONE_MODULE: {
        title: 'Módulo de zona cabo Airzone',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZDI6ZMOxxxC.png',
        descResult: '',
        conection: 'Cabo'
      },
      WIRELESS_ZONE_MODULE: {
        title: 'Módulo de zona rádio Airzone',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZDI6ZMOxxxR.png',
        descResult: '',
        conection: 'Radio'
      }
    },
    include: {
      pack: '%{name} - %{protocolo} : <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>',
      pack2: 'Kit módulo zona %{conection} Airzone %{protocolo} : <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>',
    }
  },
  UNO_SYSTEM : {
    title: 'Pack UNO',
    desc: 'Central + termostato cabo/rádio para o controlo de apenas um equipamento individual',
    img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PxxxBFCB.png',
    articles: {
      UNO_BLUEFACE_WHITE: {
        title: 'Pack Airzone UNO Termostato Blueface branco',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxBFCB.png',
        descResult: '',
        type: 'Blueface',
        color: 'Branco',
        conection: 'Cabo'
      },
      UNO_BLUEFACE_BLACK: {
        title: 'Pack Airzone UNO Termostato Blueface preto',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxBFCN.png',
        descResult: '',
        type: 'Blueface',
        color: 'Preto',
        conection: 'Cabo'
      },
      UNO_THINK_WIRELESS_WHITE: {
        title: 'Pack Airzone UNO Think radio branco',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxTHRB.png',
        descResult: '',
        type: 'Think',
        color: 'Branco',
        conection: 'Radio'
      },
      UNO_THINK_WIRELESS_BLACK: {
        title: 'Pack Airzone UNO Think radio preto',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxTHRN.png',
        descResult: '',
        type: 'Think',
        color: 'Preto',
        conection: 'Radio'
      },
      UNO_THINK_WIRED_WHITE: {
        title: 'Pack Airzone UNO Termostato Think Cabo branco',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxTHCB.png',
        descResult: '',
        type: 'Think',
        color: 'Branco',
        conection: 'Cabo'
      },
      UNO_THINK_WIRED_BLACK: {
        title: 'Pack Airzone UNO Termostato Think Cabo preto',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxTHCN.png',
        descResult: '',
        type: 'Think',
        color: 'Preto',
        conection: 'Cabo'
      }
    },
    include: {
      pack: 'Pack Airzone UNO %{protocolo} termostato %{type} (<a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>) con :',
      list1: 'Central Airzone UNO %{type} %{conection} com gateway de comunição %{protocolo} integrada.',
      list2: 'Termostato Airzone %{type} %{conection} %{color}.',
      list3: 'Cabo de barramento Airzone 10 m.',
      list4: 'Bateria de botão CR2450.',
    }
  },
  CompatibilityList: 'Lista de Compatibilidade',
  SelectBrand: 'Selecione o seu fabricante',
  SelectCompatibilityAirzone: 'Seleccione o seu dispositivo Airzone',
  SelectAtricleAirzone: 'Selecione o seu artigo Airzone',
  SelectIndoorUnitModel: 'Seleccione o modelo da unidade interna',
  ResultUnid: 'Para a unidade %{unid} (%{manufacturer})',
  ResultYourRefer: 'Sua referência da Airzone é:',
  NamePdfFile: 'Airzone-compatibilidade-referencia',
  SelectInclude: 'A sua seleção inclui:',
  ZoneSystem: 'Sistema de controle de zonas',
  MonozoneController: 'Controladores de uma zona',
  List: 'Listar',
  protocolo: {
    DA0: 'Daikin Residential',
    DA1: 'Daikin Sky Air / VRV',
    DA2: 'Daikin Altherma 3',
    FUJ: 'Fujitsu 3 wires',
    FU2: 'Fujitsu UART',
    GRE: 'Gree U-Match R410A',
    GR1: 'Gree U-Match R32',
    HAI: 'Haier',
    HIT: 'Hitachi RPI',
    HI2: 'Hitachi RAD',
    LGE: 'LG',
    MD1: 'Midea V5 protocol',
    MD2: 'Midea V6 protocol',
    MEL: 'Mitsubishi Electric',
    MHI: 'Mitsubishi Heavy',
    PA0: 'Panasonic RAC Domestic',
    PAN: 'Panasonic',
    TOS: 'Toshiba',
    SAM: 'Samsung',
    SA2: 'Samsung Nasa',
    HS1: 'Hisense',
    BAX: 'Baxi',
    BA1: 'Baxi R32',
    F3V: 'Fancoil 3 velocidades',
    FAN: 'Fancoil',
    IFR: 'IR',
    F10: 'Fancoil 0-10V',
    HI3: 'Hitachi Primairy',
    ME2: 'Mitsubishi Electric Ecodan',
  }
};
export default messages;
